<template>
  <Button type="link" variant="black" icon="general.regenerateTranscription" data-testid="viewer-transcription-regenerate" @click.prevent="regenerate"
    >Regenerate</Button
  >
</template>

<script setup lang="ts">
import { Button } from '@/storybook';
import { TrackEvents, useViewerTrack } from '@/modules/viewer/composables/useViewerTrack';
import { useTranscriptionStore } from '@/modules/viewer/store/useTranscriptionStore';

const { trackItemOwner } = useViewerTrack();
const transcriptionStore = useTranscriptionStore();

const regenerate = () => {
  trackItemOwner(TrackEvents.VIEWER_TRANSCRIPTION_REGENERATE);
  transcriptionStore.requestTranscriptions(true);
};
</script>
